import { render, staticRenderFns } from "./MostLikeTitles.vue?vue&type=template&id=56aa806c&scoped=true&"
import script from "./MostLikeTitles.vue?vue&type=script&lang=js&"
export * from "./MostLikeTitles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56aa806c",
  null
  
)

export default component.exports